import Header from 'components/header/header'
import SearchBar from 'containers/search-bar'
import locationState from 'shared/components/with-location-state'
import Page from './page'

const SupportPage = ({ content }) => (
    <Page>
        <Header />
        <SearchBar />
        <div className="blog-post">
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    </Page>
)

export default locationState(['content'])(SupportPage)
